//------------------------------ Responsive left column------------------
function responsivecolumn()
{
	if ($(document).width() <= 991)
	{
		$('.main-content .contents .page-width .side-bar').insertAfter('.main-content .contents .page-width .main-container');
	}
}
$(document).ready(function(){responsivecolumn(); });
$(window).resize(function(){responsivecolumn(); });

//==================== Mobile toggle menu ========================//
$(document).ready(function(){
  $("#MobileNav .mobile-nav__dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
  
   $("#MobileNav .mobile-nav__grand_dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile-nav__grand__item .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
});

//==================== category toggle ====================//
$(document).ready(function(){
	$(".header-bottom .categories_title").click(function(){
	$(".header-bottom #CategoryBox #SiteCat").slideToggle(800);
	$('.header-bottom .categories_title').toggleClass('active'); 
	});
});
//==================== account toggle ====================//
$('.header-top, #PageContainer').click(function() {
$(".header-bottom .tm_header-dropdown .my-account").css('display','none');
          $('.header-bottom .tm_header-dropdown').removeClass('active');
  $(".header-bottom .site-header__cart .cart-content.block").css('display','none');
          $('.header-bottom .site-header__cart').removeClass('active');
});

// $('.form_wrapper').click(function(event){
//    event.stopPropagation();
// });
$(document).ready(function(){
	$(".header-bottom .tm_header-dropdown .user-background").click(function(){
      	if($(".header-bottom .tm_header-dropdown").hasClass('active')){
	$(".header-bottom .tm_header-dropdown .my-account").css('display','none');
          $('.header-bottom .tm_header-dropdown').removeClass('active');
        }else{
	$(".header-bottom .tm_header-dropdown .my-account").css('display','block');
	$('.header-bottom .tm_header-dropdown').toggleClass('active'); 
        }
      	$(".header-bottom .site-header__cart .cart-content.block").css('display','none');

	});
});

//==================== cart toggle ====================//
$(document).ready(function(){
	$(".header-bottom .site-header__cart").click(function(){
     	if($(".header-bottom .site-header__cart").hasClass('active')){
	$(".header-bottom .site-header__cart .cart-content.block").css('display','none');
          $('.header-bottom .site-header__cart').removeClass('active');
        }else{
	$(".header-bottom .site-header__cart .cart-content.block").css('display','block');
	$('.header-bottom .site-header__cart').toggleClass('active'); 
        }
 
    
	});
});

 

//====================collection-list slider======================//
var topsliders = document.getElementById('collection-item-tm');
var topowl1 = $("#collection-item-tm");
$(topowl1).each(function (index) {
  topowl1.owlCarousel({
    items : 5, //10 items above 1000px browser width
    itemsDesktop : [1439,4], //5 items between 1000px and 901px
    itemsDesktopSmall : [989,3], // betweem 900px and 601px
    itemsTablet: [749,3], //2 items between 600 and 0
    itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
    autoPlay: true
  });
  $("a.next").click(function(){
    topowl1.trigger('owl.next');
  });
  $("a.prev").click(function(){
    topowl1.trigger('owl.prev');
  });
});

//====================Related product slider======================//
var relatedsliders = document.getElementById('related_products_slider');
var relatedowl = $("#related_products_slider");
$(relatedowl).each(function (index) {
  relatedowl.owlCarousel({
    items : 3, //10 items above 1000px browser width
    itemsDesktop : [1269,3], //5 items between 1000px and 901px
    itemsDesktopSmall : [989,3], // betweem 900px and 601px
    itemsTablet: [749,3], //2 items between 600 and 0
    itemsMobile : [479,2] // itemsMobile disabled - inherit from itemsTablet option
  });
  $(".related_next").click(function(){
    relatedowl.trigger('owl.next');
  });
  $(".related_prev").click(function(){
    relatedowl.trigger('owl.prev');
  });
});

//========================brand list slider==========================//
var brandsowl = $("#brands_list_slider");
brandsowl.owlCarousel({
  items : 7, //10 items above 1000px browser width
  itemsDesktop : [1269,6], //4 items between 1269px and 990px
  itemsDesktopSmall : [989,4], //4 items betweem 989px and 750px
  itemsTablet: [749,3], //2 items between 749 and 480
  itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
  autoPlay: true
});
$(".brands_next").click(function(){
  brandsowl.trigger('owl.next');
});
$(".brands_prev").click(function(){
  brandsowl.trigger('owl.prev');
});

//==========================back-to-top=======================//
$(window).scroll(function() {
if ($(this).scrollTop() > 500) {
$('.top_button').fadeIn(500);
} else {
$('.top_button').fadeOut(500);
}
});	
$('.top_button').click(function(event) {
event.preventDefault();	
$('html, body').animate({scrollTop: 0}, 800);
});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product_tab-block ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  $(".tm_headerlinkmenu").doubleTapToGo()
  });

//=================== thumnails slider ===================//
$(document).ready(function() {
    var addslider = $("#addition-slider");
  	  if ($(window).width() > 749){
        addslider.owlCarousel({
            items : 4 , //10 items above 1000px browser width
            itemsDesktop : [1280,4], //5 items between 1000px and 901px
            itemsDesktopSmall : [990,3], // betweem 900px and 601px
            itemsTablet: [749,4], //2 items between 600 and 0
            itemsMobile : [479,2] // itemsMobile disabled - inherit from itemsTablet option
        });
        $(".add_next").click(function(){
            addslider.trigger('owl.next'); 
        });
        $(".add_prev").click(function(){
            addslider.trigger('owl.prev');
        });
      }
});  

//======================== Sticky header ======================//
function StickyHeader(){	
	"use strict";	
	var num = 225; //number of pixels before modifying styles
	
		jQuery(window).bind('scroll', function () {
			if (jQuery(window).scrollTop() > num) {
				jQuery('.header-fix').addClass('sticky-menu');
				jQuery('.site-header-fix').addClass('header-style');
				jQuery('.category-box').addClass('home-category-fix');
				jQuery('.home-category').addClass('home-category-fix1');
				
			} else {
				jQuery('.header-fix').removeClass('sticky-menu');		
				jQuery('.site-header-fix').removeClass('header-style');
				jQuery('.category-box').removeClass('home-category-fix');
			}
		})
}
jQuery(document).ready(function() { "use strict";   StickyHeader()});
jQuery(window).resize(function() {  "use strict";   StickyHeader()});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product-single__description ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });

/*==================sidebar toggle====================*/
function mobileToggleColumn1(){
  if ($(window).width() < 990){
    $(".side-bar h3.box-heading, .side-bar .categories_title").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar h3.box-heading, .side-bar .categories_title").addClass('toggle');
    $(".side-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.box-content').slideToggle('slow');
    });    
  }
  else{
    $(".side-bar h3.box-heading, .side-bar .categories_title").removeClass('toggle');
    $(".side-bar h3.box-heading, .side-bar .categories_title").removeClass('active');
    $(".side-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn1);

/*==================footer toggle====================*/
function mobileToggleColumn(){
  if ($(window).width() < 990){
    $(".site-footer .footer-box  h5").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".site-footer .footer-box h5").addClass('toggle');
    $(".footer-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.footer-content').slideToggle('slow');
    });    
  }
  else{
    $(".site-footer .footer-box  h5").removeClass('toggle');
    $(".site-footer .footer-box h5").removeClass('active');
    $(".footer-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn);

/*================== category-box ===================*/
function mobileToggleMenu2(){
    $(".header-bottom #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".header-bottom #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".header-bottom #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');
       
    });    
}
$(document).ready(mobileToggleMenu2);

function mobileToggleMenu3(){
  
    $(" .header-bottom #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(" .header-bottom #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle');
    $(" .header-bottom #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find(' .grand-child-has-dropdown').slideToggle('slow');
       
    });    
}
$(document).ready(mobileToggleMenu3);

/*================== sidebar category-box ===================*/
function mobileToggleMenu4(){
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');    
    });    
}
$(document).ready(mobileToggleMenu4);

function mobileToggleMenu5(){
  if ($(window).width() >= 320){
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle'); 
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow'); 
    });    
  }
  else
  {
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").removeClass('toggle')
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").removeClass('active');
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleMenu5);

/*=====================  More site navigation =======================*/
function more() {
  if ($(window).width() > 1269){
    var max_elem = 5;
    var items = $('#SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="site-nav--active hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 989){
    var max_elem = 4;
    var items = $('#SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="site-nav--active hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else {
    var max_elem = 4;
    var items = $('#SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="site-nav--active hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
}
$(document).ready(function() {
    more()
});

//*======================= site cat-item ========================*/
jQuery(document).ready(function() {
	"use strict"; 
	var j = 1;							
	jQuery("ul.site-cat > .site-cat-item").each(function(i){
	   jQuery(this).addClass("cat-item-"+j);
	   j = j + 1;  if(j==17) {j=1; }
 	 });
});

//*=========================== site cat more ==============================*/
jQuery(document).ready(function(){
		var max_elem = 10 	;	
		var itemstop = jQuery('.header-bottom .site-cat > li');	
		if ( itemstop.length > max_elem ) {
			jQuery('.header-bottom .site-cat').append('<li><div class="more-wrap"><span class="more-view">More Categories</span></div></li>');
		}
		jQuery('.header-bottom .site-cat .more-wrap').on( "click",function() {
			if (jQuery(this).hasClass('active')) {
				itemstop.each(function(i) {
					if ( i >= max_elem ) {
						jQuery(this).slideUp(600);
					}
				});
				jQuery(this).removeClass('active');
				//$(this).children('div').css('display', 'block');
				jQuery('.more-wrap').html('<span class="more-view">More Categories</span>');
			} else {
				itemstop.each(function(i) {
					if ( i >= max_elem  ) {
						jQuery(this).slideDown(600);
					}
				});
				jQuery(this).addClass('active');
				jQuery('.more-wrap').html('<span class="more-view">Less Categories</span>');
			}
		});

		itemstop.each(function(i) {
			if ( i >= max_elem ) { 
				jQuery(this).css('display', 'none');
			}
		});
 });

//=============================== Reviews Slider ==================================//
	  var reviewsliders = document.getElementById('reviews_review_slider');
      var reviewowl = $("#reviews_review_slider");
      $(reviewowl).each(function (index) {
          $(this).owlCarousel({
			  pagination: !0,
        	  navigation: !1,
			  autoPlay: true,
              items : 1, //10 items above 1000px browser width
			  itemsDesktop : [1280,1], //5 items between 1000px and 901px
              itemsDesktopSmall : [990,1], // betweem 900px and 601px
              itemsTablet: [600,1], //2 items between 600 and 0
              itemsMobile : [480,1] // itemsMobile disabled - inherit from itemsTablet option
          });

          $(".reviews_next").click(function(){
              $(reviewowl).trigger('owl.next');
          });
          $(".reviews_prev").click(function(){
              $(reviewowl).trigger('owl.prev');
          });
   	  });

//===================================== Insert after easy access links ==================================//
if ($(window).width() < 750){
  $( "ul.easy-access_links .access.links" ).insertAfter( $( "li.mobile-nav__item.border-bottom:last-child" ) );
}


//===================================== Product tab slider ==================================//

function addfl(){
	this.$owlItems.removeClass('first last');
	this.$owlItems.eq(this.currentItem).addClass('first');
	this.$owlItems.eq(this.currentItem + (this.owl.visibleItems.length - 1)).addClass('last');
}

//======================camera product collection slider======================//
var camerassliders = document.getElementById('cameras_products_slider');
var camerasowl = $("#cameras_products_slider");
$(camerasowl).each(function (index) {
  $(this).owlCarousel({
    items : 6, //10 items above 1000px browser width
    itemsDesktop : [1269,4], //5 items between 1000px and 901px
    itemsDesktopSmall : [989,3], // betweem 900px and 601px
    itemsTablet: [749,3], //2 items between 600 and 0
    itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
	afterAction: addfl
  });

  $(".cameras_next").click(function(){
    $(camerasowl).trigger('owl.next');
  });
  $(".cameras_prev").click(function(){
    $(camerasowl).trigger('owl.prev');
  });
});

//======================camera product collection slider======================//
var electronicssliders = document.getElementById('electronics_products_slider');
var electronicsowl = $("#electronics_products_slider");
$(electronicsowl).each(function (index) {
  $(this).owlCarousel({
    items : 6, //10 items above 1000px browser width
    itemsDesktop : [1269,4], //5 items between 1000px and 901px
    itemsDesktopSmall : [989,3], // betweem 900px and 601px
    itemsTablet: [749,3], //2 items between 600 and 0
    itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
	afterAction: addfl
  });

  $(".electronics_next").click(function(){
    $(electronicsowl).trigger('owl.next');
  });
  $(".electronics_prev").click(function(){
    $(electronicsowl).trigger('owl.prev');
  });
});